const state = {
  openProjects: []
};

const getters = {
  getOpenProjects(state) {
    return state.openProjects;
  }
};

const mutations = {
  setOpenProjects(store, openProjects) {
    store.openProjects = openProjects;
  }
};

const actions = {
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
